import { BLACK_d, BLACK_e } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 23.5rem;
  margin-bottom: 33rem;

  & > span {
    font-weight: 700;
    font-size: 5.2rem;
    line-height: 9.2rem;
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 10rem;
    margin-bottom: 30rem;
    align-items: baseline;
    & > span {
      font-size: 2.8rem;
      line-height: 5rem;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8rem;
  margin-top: 6rem;
  width: 100%;
  height: 134rem;
  position: relative;

  & > img {
    left: 50%;
    transform: translate(-50%);
    position: absolute;
    width: 2rem;
  }

  & > div:nth-child(2n) {
    margin-left: 67rem;
  }
  & > div:nth-child(2n + 1) {
    margin-left: ${(props) => (props.language === "en" ? "10rem" : "19.5rem")};
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    height: 130rem;
    & > img {
      left: 20px;
      position: absolute;
      width: 2rem;
      height: ${(props) => (props.language === "en" ? "150rem" : "")};
    }

    & > div:nth-child(2n) {
      margin-left: calc(20px + 1.8rem);
    }
    & > div:nth-child(2n + 1) {
      margin-left: calc(20px + 1.8rem);
    }
  }
`;

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 2rem;
  & > span:nth-child(1) {
    font-weight: 700;
    font-size: 3.2rem;
    line-height: 5.4rem;
    color: ${BLACK_e};
  }

  & > span:nth-child(2) {
    margin-top: 2rem;
    margin-bottom: 1rem;
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 4.2rem;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    padding-top: 4rem;
    white-space: nowrap;
    & > span:nth-child(2) {
      margin-top: 1.5rem;
      margin-bottom: 0.5rem;
      font-size: 2rem;
      line-height: 3.6rem;
    }
  }
`;

export const List = styled.div`
  display: flex;
  gap: 0.9rem;

  & > span:nth-child(1) {
    width: 0.3rem;
    height: 0.3rem;
    background-color: ${BLACK_d};
    margin-top: 1.9rem;
  }
  & > span:nth-child(2) {
    margin-top: 0.5rem;
    font-weight: 300;
    font-size: 1.8rem;
    line-height: 3.2rem;
    color: ${BLACK_d};
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    & > span:nth-child(1) {
      width: 0.2rem;
      height: 0.2rem;
    }
    & > span:nth-child(2) {
      font-size: 1.6rem;
      line-height: 2.8rem;
      white-space: normal;
    }
  }
`;
